// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__product___pZTsR {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
  margin-bottom: 20px;
  width: 100%;
}
@media (min-width: 991px) {
  .styles__product___pZTsR {
    width: 30%;
  }
}
.styles__flexCenter___LkFZb {
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles__productTitle___ak_t9 {
  font-size: 20px;
  flex-direction: column;
  margin: 0.5em 0 0.25em 0;
  line-height: 1.1em;
}
.styles__productTitle___ak_t9 em {
  font-size: 0.85em;
}
.styles__characteristicsTitle___JdOKj {
  width: 100%;
  border-bottom: 1px solid #d8d8d8;
  font-size: 14px;
}
.styles__characteristicsSection_____bL9 {
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #d8d8d8;
}
.styles__button___xLsoA {
  width: 100%;
  height: 48px;
}
.styles__content___YLEiV {
  padding: 15px 15px 0px 15px;
}
.styles__content___YLEiV > .styles__row___bLdJT {
  margin: 0px;
}
.styles__input___HvOga {
  border: none !important;
  border-bottom: 1px solid grey !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.styles__accentedCell___hUHdJ {
  padding-top: 10px;
  padding-bottom: 10px;
}
.styles__commentInput___u70wj {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 40px;
  margin-top: 20px;
}
.styles__propertyTitle___b2eUU {
  font-size: 12px;
  color: #7F7F7F;
}
.styles__summary___GHBuK {
  color: #7F7F7F;
  font-size: 12px;
}
.styles__quantityInCart___wIhyt {
  text-align: right;
}
.styles__price___tZ9LJ {
  margin-right: 4px;
}
.styles__comment___jHZLD {
  margin-bottom: 10px;
  margin-top: 10px;
  color: #D9534F;
}
.styles__limitedQuantityMessage___jxvlh {
  color: #d9534f;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/SearchResults/ProductsList/RimProduct/styles.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AADF;AAEE;EAAA;IACE,UAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAGA;EAEE,eAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;AADF;AAJA;EAOI,iBAAA;AAAJ;AAIA;EACE,WAAA;EACA,gCAAA;EACA,eAAA;AAFF;AAKA;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AAHF;AAMA;EACE,WAAA;EACA,YAAA;AAJF;AAOA;EACE,2BAAA;AALF;AAIA;EAII,WAAA;AALJ;AASA;EACE,uBAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;AAPF;AAUA;EACE,iBAAA;EACA,oBAAA;AARF;AAWA;EACE,uBAAA;EACA,2BAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AATF;AAYA;EACE,eAAA;EACA,cAAA;AAVF;AAaA;EAEE,cAAA;EACA,eAAA;AAXF;AAcA;EACE,iBAAA;AAZF;AAeA;EACE,iBAAA;AAbF;AAgBA;EAEE,mBAAA;EACA,gBAAA;EACA,cAAA;AAdF;AAiBA;EACE,cAAA;AAfF","sourcesContent":["@import '../../../../../../shared/variables.less';\n\n.product {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: white;\n  margin-bottom: 20px;\n  width: 100%;\n  @media (min-width: 991px) {\n    width: 30%;\n  }\n}\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.productTitle {\n  composes: flexCenter;\n  font-size: 20px;\n  flex-direction: column;\n  margin: 0.5em 0 0.25em 0;\n  line-height: 1.1em;\n  em {\n    font-size: 0.85em;\n  }\n}\n\n.characteristicsTitle {\n  width: 100%;\n  border-bottom: 1px solid #d8d8d8;\n  font-size: 14px;\n}\n\n.characteristicsSection {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #d8d8d8;\n}\n\n.button {\n  width: 100%;\n  height: 48px;\n}\n\n.content {\n  padding: 15px 15px 0px 15px;\n  // font-size: 12px;\n  > .row {\n    margin: 0px;\n  }\n}\n\n.input {\n  border: none !important;\n  border-bottom: 1px solid grey !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n\n.accentedCell {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.commentInput {\n  border: none !important;\n  box-shadow: none !important;\n  border-bottom: 1px solid #ccc !important;\n  margin-bottom: 40px;\n  margin-top: 20px;\n}\n\n.propertyTitle {\n  font-size: 12px;\n  color: @eon-text-color-muted;\n}\n\n.summary {\n  composes: flexCenter;\n  color: @eon-text-color-muted;\n  font-size: 12px;\n}\n\n.quantityInCart {\n  text-align: right;\n}\n\n.price {\n  margin-right: 4px;\n}\n\n.comment {\n  composes: flexCenter;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  color: @eon-text-color-red;\n}\n\n.limitedQuantityMessage {\n  color: @danger;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product": `styles__product___pZTsR`,
	"flexCenter": `styles__flexCenter___LkFZb`,
	"productTitle": `styles__productTitle___ak_t9 styles__flexCenter___LkFZb`,
	"characteristicsTitle": `styles__characteristicsTitle___JdOKj`,
	"characteristicsSection": `styles__characteristicsSection_____bL9`,
	"button": `styles__button___xLsoA`,
	"content": `styles__content___YLEiV`,
	"row": `styles__row___bLdJT`,
	"input": `styles__input___HvOga`,
	"accentedCell": `styles__accentedCell___hUHdJ`,
	"commentInput": `styles__commentInput___u70wj`,
	"propertyTitle": `styles__propertyTitle___b2eUU`,
	"summary": `styles__summary___GHBuK styles__flexCenter___LkFZb`,
	"quantityInCart": `styles__quantityInCart___wIhyt`,
	"price": `styles__price___tZ9LJ`,
	"comment": `styles__comment___jHZLD styles__flexCenter___LkFZb`,
	"limitedQuantityMessage": `styles__limitedQuantityMessage___jxvlh`
};
export default ___CSS_LOADER_EXPORT___;
